module.exports = __webpack_public_path__ + "static/img/first-ios.97f4b79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/first-ios.png
// module id = EHsd
// module chunks = 0